import { useState } from "react";
import { RootStateOrAny, useSelector } from "react-redux";
import { useGetResumoDoDia } from "services/api/Common_Campanhas/get-resumo-do-dia";
import { AuthState } from "store/ducks/auth/types";
import * as S from "./styles";

function CampanhasCorretor() {
  const { linkToken3cplus } = useSelector<RootStateOrAny, AuthState>(
    (state) => state.user
  );
  const [showIframe, setShowIframe] = useState(false);
  const { data: resumoDoDia } = useGetResumoDoDia({
    queryKey: "resumo_do_dia",
  });

  const handleEncerrarChamadas = () => {
    setShowIframe(false);
  };

  const mapCards = [
    {
      title: "Contatos exibidos",
      value: "Contatos exibidos",
      qtd: resumoDoDia?.totalContatosExibidos,
      icon: "📞",
      color: "#06D986",
      bgColor: "#E8F8F0",
    },
    {
      title: "Com interesse",
      value: "Com interesse",
      qtd: resumoDoDia?.totalComInteresse,
      icon: "⭐",
      color: "#4A76FB",
      bgColor: "#E8F0FF",
    },
    {
      title: "Visitas agendadas",
      value: "Visitas agendadas",
      qtd: resumoDoDia?.totalVisitaAgendada,
      icon: "📅",
      color: "#8B5CF6",
      bgColor: "#F0E8FF",
    },
    {
      title: "Descartados",
      value: "Descartados",
      qtd: resumoDoDia?.totalDescartados,
      icon: "🗑️",
      color: "#EF4444",
      bgColor: "#FEE8E8",
    },
    {
      title: "Mudo/Ligação caiu",
      value: "Mudo/Ligação caiu",
      qtd: resumoDoDia?.totalMudoLigacaoCaiu,
      icon: "🔇",
      color: "#6B7280",
      bgColor: "#F3F4F6",
    },
    {
      title: "Descadastro",
      value: "Descadastro",
      qtd: resumoDoDia?.totalDescadastrados,
      icon: "❌",
      color: "#F97316",
      bgColor: "#FEF3E8",
    },
  ];
  return (
    <>
      <S.Container>
        <S.Row>
          <S.Column>
            <S.Row style={{ gap: "16px" }}>
              {showIframe ? (
                <S.ButtonEndCall onClick={handleEncerrarChamadas}>
                  Encerrar chamada
                </S.ButtonEndCall>
              ) : (
                <S.ButtonStartCall onClick={() => setShowIframe(true)}>
                  Iniciar 3C.plus
                </S.ButtonStartCall>
              )}
            </S.Row>
          </S.Column>
          <S.Column>
            <S.Title>Resumo do dia</S.Title>
            <S.CardsContainer>
              {mapCards.map((card) => (
                <S.Card
                  style={{
                    background: card.bgColor,
                  }}
                  key={card.title}
                >
                  <S.CardContent>
                    <S.IconContainer>
                      <S.IconText>{card.icon}</S.IconText>
                    </S.IconContainer>
                    <S.NumberText style={{ color: card.color }}>
                      {card.qtd}
                    </S.NumberText>
                  </S.CardContent>
                  <S.TitleCard style={{ color: card.color }}>
                    {card.title}
                  </S.TitleCard>
                </S.Card>
              ))}
            </S.CardsContainer>
          </S.Column>
        </S.Row>
      </S.Container>
      {showIframe && (
        <S.IframeContainer>
          <S.IframeTitle>Mesa Telefônica - 3C.plus</S.IframeTitle>
          <S.Iframe
            src={linkToken3cplus}
            title="Mesa Telefônica"
            allow="microphone; camera; autoplay; clipboard-write"
            sandbox="allow-same-origin allow-scripts allow-forms allow-popups allow-popups-to-escape-sandbox"
          />
        </S.IframeContainer>
      )}
    </>
  );
}

export default CampanhasCorretor;
